import script from "./LoginFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginFormView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginFormView.vue?vue&type=style&index=0&id=cb94e2ae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb94e2ae"]])

export default __exports__